import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const PageGalleryContainer = styled('div')(css`
    position: relative;
    width: 100%;
    padding-top: 66.66667%;
`);

export const PageGalleryContent = styled('div')(css`
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
`);

export const ModalGalleryContainer = styled('div')(
    ({ theme }) => css`
        position: relative;
        width: 100%;
        margin: ${theme.spacing['16px']} auto;
    `
);
